var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("Company Time: "+_vm._s(_vm.companyTime))])
}
var staticRenderFns = []

export { render, staticRenderFns }